import * as React from 'react';
import axios from "axios";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { red } from "@mui/material/colors";
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Rating from '@mui/material/Rating';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';

import { uploadTypeImagesApiRequest, uploadImagesCloudinaryApiRequest } from "../utils/utils.js";

import AdminMenuComponent from "../../../components/admin/AdminMenuComponent.js";
import ElementCardForPageComponent from "./ElementCardForPageComponent.js";
import { cyan } from "@mui/material/colors";

import CreateTypeElementCard from "./CreateTypeElementCard.js";

const config = require("../../../constants/constants.js")

const onHover = {
  cursor: "pointer",
  position: "absolute",
  left: "5px",
  top: "-10px",
  transform: "scale(2.7)",
};

const EditTypePageComponent = ({ updateTypeApiRequest, fetchType }) => {

  const [validated, setValidated] = useState(false);
  const [type, setType] = useState([]);
  const [updateTypeResponseState, setUpdateTypeResponseState] = useState({ message: "", error: "" });

  const [isUploading, setIsUploading] = useState("");
  const [imageUploaded, setImageUploaded] = useState(false);
  const [imageRemoved, setImageRemoved] = useState(false)

  const { id } = useParams();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [position, setPosition] = useState(0);
  const [note, setNote] = useState("");
  const [color, setColor] = useState("");
  const [image, setImage] = useState("");
  const [images, setImages] = useState([]);

  useEffect(() => {
    fetchType(id)
      .then(data => {
        setType(data);
      })
      .catch((er) => console.log(er.response.data.message ? er.response.data.message : er.response.data));
    //console.log('type = ',type)
  }, [id])

  useEffect(() => {
    fetchType(id)
      .then(data => {
        //console.log(`data =`, data);  
        setName(data?.name);
        setDescription(data?.description);
        setPosition(data?.position);
        setNote(data?.note);
        setColor(data?.color);
        setImage(data?.image);
        setImages(data?.images);
        //console.log(`name  =`, name);  
        //console.log(`description  =`, description);  
      })
      .catch((er) => console.log(er.response.data.message ? er.response.data.message : er.response.data));
  }, [id])


  const uploadTypeImagesApiRequest = async (images, typeId) => {

    console.log("[uploadTypeImagesApiRequest]")
    console.log("[uploadTypeImagesApiRequest] images=", images)
    console.log("[uploadTypeImagesApiRequest] id=", typeId)

    const formData = new FormData();
    Array.from(images).forEach((image) => {
      formData.append("images", image);
    });

    console.log("[uploadTypeImagesApiRequest] formData=", formData)
    console.log("[uploadTypeImagesApiRequest] POST /api/types/admin/upload?typeId")

    const { data } = await axios.post("/api/types/admin/upload?typeId=" + typeId, formData);
    return data;
  };

  function handleSalva(eventKey) {
    eventKey.preventDefault();
    eventKey.stopPropagation();

    //console.log(`[handleSalva] name dig =`, name);  
    //console.log(`[handleSalva] description dig =`, description);  
    //console.log(`[handleSalva] color dig =`, color);  
    //console.log(`[handleSalva] image dig =`, image);  

    const formInputs = {
      name: name,
      description: description,
      position: position,
      note: note,
      color: color,
      image: image,
      images: images,
    };

    updateTypeApiRequest(id, formInputs)
      .then(data => {
        if (data.success === "resource updated") {
          navigate("/admin/types");
        }
      })
      .catch(er => {
        setUpdateTypeResponseState({ error: er.response.data.message ? er.response.data.message : er.response.data });
      })

    window.location.assign('/admin/types')
  }

  const handleLoadImage = (event) => {
    const files = Array.from(event.target.files);
    const statusStep = 100 / files.length;

    console.log("[handleLoadImage] event.target.files=" + event.target.files)
    console.log("[handleLoadImage] files.length=" + files.length)

    for (let i = 0; i < files.length; i++) {
      // ## controllo dimensione totale
      //
      // uploadItem(files[i]);
      // Here it guarantees that state updated correctly
      // setState(prevStep => prevStep + statusStep);
    }

    setIsUploading("upload files in corso ...");
    if (process.env.NODE_ENV !== "production") {
      uploadTypeImagesApiRequest(event.target.files, id)
        .then(data => {
          setIsUploading("upload files completato");
          setImageUploaded(!imageUploaded);
        })
        .catch((er) => setIsUploading(er.response.data.message ? er.response.data.message : er.response.data));
    } else {
      uploadTypeImagesApiRequest(event.target.files, id)
        .then(data => {
          setIsUploading("upload files completato");
          setImageUploaded(!imageUploaded);
        })
        .catch((er) => setIsUploading(er.response.data.message ? er.response.data.message : er.response.data));
    }
    window.location.assign(`/admin/edit-type/${id}`)
};

  function gotoIndietro(eventKey) {
    eventKey.preventDefault();
    eventKey.stopPropagation();

    window.location.assign('/admin/types')
  }

  return (

    <Box sx={{ flexGrow: 1 }}>

      <Grid container spacing={2}>

        <AdminMenuComponent></AdminMenuComponent>

        <Box
          paddingLeft={{ xs: 3, md: 3 }}
        >

          <Breadcrumbs separator="›" aria-label="breadcrumb"
            size={{ xs: 12, md: 4 }}
            paddingTop={{ xs: 3, md: 3 }}
            paddingLeft={{ xs: 0, md: 0 }}
            paddingRight={{ xs: 1, md: 8 }}
            spacing={{ xs: 2, md: 2 }}
          >
            <Link underline="hover" color="inherit" href="">
              {config.BC_ADMIN}
            </Link>
            <Link underline="hover" color="inherit" href="/admin/types">
              {config.BC_ADMIN_TYPES}
            </Link>
            <Typography sx={{ color: 'text.primary' }}>{config.BC_ADMIN_TYPES_EDIT}</Typography>
          </Breadcrumbs>

          <Stack
            sx={{ flexDirection: { xs: "row", md: "row" }, paddingTop: 2, paddingLeft: 0, paddingRight: 0, }}
          >

            <Typography
              sx={{ paddingTop: 0, paddingLeft: 0, paddingRight: 0, }}
              variant="h4"
            >
              <b>Modifica tipologia</b>&nbsp;
            </Typography>
          </Stack>

          <Grid
            useFlexGap
            sx={{
              flexDirection: { xs: "column", md: "row" },
              paddingTop: 2, paddingLeft: 0, paddingRight: 0,
              flexWrap: 'wrap'
            }}
          >

            <Box
              sx={{
                flexDirection: { xs: "column", md: "column" },
              }}
            >

              <Box
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  height: 30
                }}
              />

              <Paper
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  background: '#cce0e6'
                }}
                elevation={6}
              >

                <Stack
                  useFlexGap
                  sx={{
                    flexDirection: { xs: "column", md: "row" },
                    paddingTop: 2, paddingLeft: 0, paddingRight: 0,
                    flexWrap: 'wrap'
                  }}
                >

                  <TextField id="id-name" label="Nome" variant="outlined" value={name} defaultValue={name}
                    sx={{
                      width: "65ch",
                      p: { xs: 1, md: 1 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setName(event.target.value);
                    }}
                  />

                  <TextField id="id-description" label="Descrizione" variant="outlined" value={description} defaultValue={description}
                    sx={{
                      width: "65ch",
                      p: { xs: 1, md: 1 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setDescription(event.target.value);
                    }}
                  />

                  <TextField id="id-position" label="Posizione" variant="outlined" value={position} defaultValue={position} type="number" InputProps={{ inputProps: { min: 0 } }}
                    sx={{
                      width: "15ch",
                      p: 1,
                      m: 1,
                    }}
                    onChange={(event) => {
                      setPosition(event.target.value);
                    }}
                  />

                  <TextField id="id-color" label="Colore" variant="outlined" value={color} defaultValue={color} type="color"
                    sx={{
                      width: "20ch",
                      p: { xs: 1, md: 1 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setColor(event.target.value);
                    }}
                  />

                  <TextField id="id-note" label="Note" variant="outlined" value={note} defaultValue={note} 
                    sx={{
                      width: "65ch",
                      p: { xs: 1, md: 1 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setNote(event.target.value);
                    }}
                    multiline
                    rows={3}
                    maxRows={6}
                  />

                </Stack>

                <Stack
                  sx={{
                    paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                    display: 'flex',
                    flexDirection: { xs: "row", md: "row" },
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >

                  <Button
                    type="button"
                    variant="contained"
                    color="warning"
                    onClick={(e) => { gotoIndietro(e); }}
                    sx={{
                      width: "12ch",
                      p: { xs: 1, md: 1 },
                      m: { xs: 1, md: 1 },
                    }}
                  >
                    Indietro
                  </Button>

                  <Button
                    type="button"
                    variant="contained"
                    color="success"
                    onClick={(e) => { handleSalva(e); }}
                    sx={{
                      width: "12ch",
                      p: { xs: 1, md: 1 },
                      m: { xs: 1, md: 1 },
                    }}
                  >
                    Salva
                  </Button>
                </Stack>

                <Box
                  sx={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                    height: 20
                  }}
                />

              </Paper>

              <Box
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  height: 30
                }}
              />

              <Paper
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  background: '#cce0e6'

                }}
                elevation={6}
              >

                <Box
                  sx={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  }}
                >

                  <Stack
                    sx={{
                      paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                      display: 'flex',
                      flexDirection: { xs: "row", md: "row" },
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  >

                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      size="small"
                      component="label"
                      fullWidth
                      sx={{
                        width: "20ch",
                        p: 1,
                        m: 1,
                      }}
                    >
                      Carica immagine
                      <input type="file" onChange={handleLoadImage} hidden multiple />
                    </Button>

                    <Typography variant="h6" color="navy"
                      sx={{
                        width: "20ch",
                        p: 1,
                        m: 1,
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 0,
                      }}
                    >
                      {images.length} immagini caricate
                    </Typography>

                    <Typography variant="h9" color="black"
                      sx={{
                        width: "50ch",
                        p: 1,
                        m: 1,
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 0,
                      }}
                    >
                      puoi modificare titoli e info
                    </Typography>

                  </Stack>

                  <Stack
                    sx={{
                      flexDirection: { xs: "row", md: "row" },
                      paddingTop: 0, paddingLeft: 0, paddingRight: 0, paddingBottom: 1,
                      position: "center", overflowX: "scroll",
                      '@media (min-width: 600px)': { width: '1400px' },
                      '!@media (min-width: 600px)': { width: '500px' },
                    }}
                  >

                    {images.map((image, idx) => (

                      <CreateTypeElementCard key={idx} imagePath={image.path} idx={idx} pageId={id} nameImage={image.name} titleImage={image.title} subTitleImage={image.subTitle} pageAll={type} />

                    ))}

                  </Stack>

                </Box>

              </Paper>

              <Box
                sx={{
                  paddingTop: 4, paddingBottom: 0, paddingLeft: 0, paddingRight: 0
                }}
              />

            </Box>

          </Grid>

        </Box>

      </Grid>

    </Box>

  );
};

export default EditTypePageComponent;
